<template>
  <section class="ni-section ni-ask" id="qd-service">
    <div class="ni-container">
      <SectionHeader
        variant="dark"
        :subtitle="t('newIndex.sections.ask.subtitle')"
      >
        <template #title>
          <span class="ni-section-header__title-mark">
            {{ t('newIndex.sections.ask.title') }}
          </span>
        </template>
      </SectionHeader>

      <div class="ni-ask__grid">
        <a
          v-for="srv in serviceItems"
          :key="srv.id"
          :id="`service-card-${srv.id}`"
          class="ni-ask__card"
          :class="{ 'ni-ask__card--title-only': isTitleOnlyCard(srv.id) }"
          :href="srv.redirectUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <div class="ni-ask__card-icon">
            <img :src="getServiceIcon(srv.id)" :alt="getCardTextLines(srv.id)[0]" class="ni-ask__card-icon-img" />
          </div>
          <div class="ni-ask__card-text">
            <div
              v-for="(line, lineIdx) in getCardTextLines(srv.id)"
              :key="lineIdx"
              :class="lineIdx === 0 ? 'ni-ask__card-line1' : 'ni-ask__card-line2'"
            >
              {{ line }}
            </div>
          </div>
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { serviceItems } from '@/data/newIndexMock.js';
import { getServiceIcon } from '@/data/newIndexAssets.js';
import SectionHeader from './shared/SectionHeader.vue';

const { t, tm } = useI18n();

function getCardTextLines(id) {
  const cards = tm('newIndex.sections.ask.cards');
  if (cards && cards[id]) {
    return cards[id];
  }
  return [];
}

function isTitleOnlyCard(id) {
  return getCardTextLines(id).length === 1;
}
</script>

